import { render, staticRenderFns } from "./CorpInfo.vue?vue&type=template&id=75441cdd&scoped=true&"
import script from "./CorpInfo.vue?vue&type=script&lang=ts&"
export * from "./CorpInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CorpInfo.vue?vue&type=style&index=0&id=75441cdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75441cdd",
  null
  
)

export default component.exports